import React from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";

const data = [
    { name: "JAN", "SEK": 51000 },
    { name: "FEB", "SEK": 42000 },
    { name: "MAR", "SEK": 40000 },
    { name: "APR", "SEK": 35000 },
    { name: "MAJ", "SEK": 24000 },
    { name: "JUN", "SEK": 40000 },
    { name: "JUL", "SEK": 22000 },
    { name: "AUG", "SEK": 82000 },
    { name: "SEP", "SEK": 42000 },
    { name: "OKT", "SEK": 33000 },
    { name: "NOV", "SEK": 37000 },
    { name: "DEC", "SEK": 40000 }
];

const Diagram = ({ width }) => {
    return (
        <div className="d-flex justify-content-start">
            <ResponsiveContainer width="97%" height={400}>
                <BarChart
                    data={data}
                    margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                >
                    <XAxis tick={{ fill: 'white' }} dataKey="name" />
                    <YAxis tick={{ fill: 'white' }} type="number" domain={[0, 100000]} />
                    <CartesianGrid strokeDasharray="0" stroke="#0c969c" />
                    <Tooltip cursor={{ stroke: '#0c969c', strokeWidth: 1, fill: "#0c969c" }} />

                    <Bar
                        dataKey="SEK"
                        fill="#054447"
                    />
                </BarChart>
            </ResponsiveContainer >
        </div >
    );
};

const mapStateToProps = ({ settings }) => {
    const { width } = settings;
    return { width };
};

export default connect(mapStateToProps)(Diagram);
